import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

export const DEFAULT_CONTENT = {
  hero: {
    name: "Yosimar de Paz",
    stageName: "El Compa Yosi",
    tagline: "Mi voz, mi historia y mi pasión por conectar con la gente",
    description: "Actor, locutor y empresario",
  },
  historiaHeading: "De Tonalá, Chiapas al micrófono",
  biography: [
    "Soy Yosimar de Paz, conocido como El Compa Yosi: actor, locutor y empresario radicado en Huntsville, Alabama. Mi trayectoria en los medios comenzó alrededor de los 13 años en Tonalá, Chiapas.",
  ],
  photos: { fondo: "/assets/fondo.jpg", historia: "/assets/retrato.jpg" },
  gallery: [],
  timeline: [
    { period: "Alrededor de los 13 años", title: "Inicio en La Digital 89.5 FM", description: "Tonalá, Chiapas, como El Flaco de la FM.", logo: null },
    { period: "Etapa en Chiapas", title: "Colaboración en Aficionarte", description: "Como operador y conductor provisional durante algunos programas.", logo: null },
    { period: "2009–2010", title: "Corazón salvaje", description: "Participación como extra, Veracruz.", logo: null },
    { period: "Película estrenada en 2013", title: "La jaula de oro", description: "Participación en la película dirigida por Diego Quemada-Díez.", logo: null },
    { period: "Actualidad", title: "Radio como El Compa Yosi", description: "Creación de contenido y emprendimiento.", logo: "/assets/laraza.png", logoAlt: "La Raza 94.7 FM / 890 AM" },
  ],
  projects: [],
  contact: {
    heading: "¿Creamos algo juntos?",
    text: "Contáctame para publicidad, entrevistas, eventos, creación de contenido y colaboraciones.",
    email: "yosimarpaz93@gmail.com",
    countryCode: "1",
    phone: "(256) 288-8270",
    whatsapp: "https://wa.me/12562888270",
  },
  socials: {
    instagram: "https://www.instagram.com/elcompayosiradio/",
    tiktok: "https://www.tiktok.com/@elcompayosiradio",
    youtube: null,
  },
};

const Ctx = createContext({ content: DEFAULT_CONTENT, setContent: () => {} });
export const useContent = () => useContext(Ctx);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    api
      .get("/content")
      .then(({ data }) => setContent({ ...DEFAULT_CONTENT, ...data }))
      .catch(() => {});
  }, []);
  return <Ctx.Provider value={{ content, setContent }}>{children}</Ctx.Provider>;
};
